import IClientCurrencySettings from '../../../services/ClientManagementSettings/types/IClientCurrencySettings';
import IArrangementLevel from '../../ClientManagementSettings/types/IArrangementLevel';

import ClientContactDTO from './ClientContactDTO';
import { IFeeArrangementFile } from './IFeeArrangementFile';

interface FeeArrangementDTO {
  id?: string;
  name: string;
  createdBy: string;
  createdOn: Date;
  contractType: string;
  currency: IClientCurrencySettings;
  fee: number;
  feeType: string;
  billRateExpense?: string;
  startDate: Date;
  endDate: Date;
  employmentGuarantee: number;
  empGuaranteePeriodUnit: string;
  clientId: string;
  clientContact?: ClientContactDTO;
  feeArrangementLevel: IArrangementLevel;
  workspaceId: string;
  approved: boolean;
  value: string;
  feeArrangementFiles: IFeeArrangementFile[];
  paymentTerms?: number;
  invoiceTerms?: number;
  isArchive?: boolean;
}

class FeeArrangementDTO {
  constructor(feeArrangementDTO: FeeArrangementDTO) {
    Object.assign(this, feeArrangementDTO);
  }
}

export default FeeArrangementDTO;
